import { OrderForm, WorkDay } from '@core/models';
import { CheckoutOrderValidationError } from '../enum/checkout-order-validation.enum';

export function prepareCheckoutOrder(input: { order: OrderForm; workDay: WorkDay }): OrderForm {
	return {
		...input.order,
		workDay: input.workDay,
		cartList: input.order.cartList.filter(item => item.storeSlug === input.order.storeData.slug),
	};
}

export function getCheckoutOrderValidationMessage(
	error: CheckoutOrderValidationError,
	unavailableProducts: readonly string[]
): string {
	switch (error) {
		case CheckoutOrderValidationError.ProductsUnavailable:
			return `The ${unavailableProducts.join(', ')} products are not available at this time and have not been included in your order.`;
		case CheckoutOrderValidationError.DeliveryZoneUnavailable:
			return "You are not in the store's delivery zone";
		case CheckoutOrderValidationError.OrderTypeUnavailable:
			return 'Order type is not available';
		case CheckoutOrderValidationError.OrderDataIncomplete:
			return 'Store ID not available';
		case CheckoutOrderValidationError.StoreClosed:
			return 'SILENT_STORE_CLOSED';
		case CheckoutOrderValidationError.PaymentDataIncomplete:
			return 'Payment information is incomplete';
	}
}
